import uniq from 'lodash/uniq';
import { getState as getRootState } from '../selectors';
import { REDUCER_NAME } from './constants';

export const getState = (state) => getRootState(state)[REDUCER_NAME];

export const getCurrentLocation = (state) => {
  let { country = [DEFAULT_COUNTRY], lat, lng } = getState(state);
  if (['local', 'test'].includes(ENV)) {
    country = null;
  }
  return { country, lat, lng };
};
